import type { McpGrantListItem } from '@dawn/feature-config';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { mcpOAuthApi, type McpGrantScope } from '@/lib/api';

import { queryKeys } from './query-keys';

/**
 * The connected MCP apps in `scope`: GET /mcp/oauth/grants — every Admin's
 * (`users.manage`, Super Admin) — or GET /mcp/oauth/grants/own — the caller's
 * own (`data.view`, TDEV-1234).
 */
export function useMcpGrantsQuery(scope: McpGrantScope): UseQueryResult<McpGrantListItem[]> {
  return useQuery({
    queryKey: queryKeys.mcpOAuth.grants(scope),
    queryFn: ({ signal }) => mcpOAuthApi.listGrants(scope, signal),
  });
}
